var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{attrs:{"title":_vm.title}}),_vm._l(((this.$route.query.index === 0?_vm.imgPath2021:_vm.imgPath2022)),function(item,index){return _c('img',{key:index,staticClass:"img",attrs:{"width":"100%","src":item.imgPath,"alt":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }